import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Archivo} from "./archivo.model";

@BasicEntity({
    name: 'Archivo Dentalcad',
    endpoint: 'archivo_blender_dentalcads',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ArchivoBlenderDentalcad"
})
export class ArchivoBlenderDentalcad extends Archivo {
    public static readonly BLENDER_MAP: PropertyMap = {
        name: 'Blender',
        type: PropertyType.FutureUri('blender.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ArchivoBlenderDentalcad.BLENDER_MAP)
    private _blender;

    get blender() {
        return this._blender;
    }

    set blender(value) {
        this._blender = value;
    }
}
